import { useEffect, useState } from 'react';

import Button from '../Button';
import './style.css';

export type ModalProps = {
    isOpen: boolean;
    title?: string;
    text?: string;
    onClose?: () => void; 
};

const Modal = ({ title, text, isOpen, onClose }: ModalProps) => {
    const [open, setOpen] = useState(isOpen);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    const handleClose = () => {
        setOpen(false);
        onClose && onClose();
    }

    return (
        <div className={`modal ${open && 'active'}`}>
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{title}</h2>
                </div>
                <div className="modal-body">
                    <div dangerouslySetInnerHTML={{ __html: text as string }} />
                </div>
                <div className="modal-footer">
                    <Button text="OK" onClick={() => handleClose()} />
                </div>
            </div>
        </div>
    );
}

export default Modal;